import * as React from 'react'

import { ProductItemSkeleton } from '@thg-commerce/enterprise-widget-product-list-page/src/ProductItem'

import { GridContainer, ListWrapper, TextSkeleton } from './styles'

export const ProductRecSkeleton = () => {
  return (
    <ListWrapper>
      <TextSkeleton />
      <GridContainer>{ProductItemSkeleton(4)}</GridContainer>
    </ListWrapper>
  )
}
